var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAnamnesis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.744,
    height: 88.745,
    viewBox: "0 0 88.744 88.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1039",
    "data-name": "Grupo 1039",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_2",
    "data-name": "Sustracci\\xF3n 2",
    d: "M44.373,88.745A44.384,44.384,0,0,1,27.1,3.487,44.384,44.384,0,0,1,61.644,85.258,44.094,44.094,0,0,1,44.373,88.745ZM32.252,51.2a3.286,3.286,0,1,0,3.286,3.285A3.288,3.288,0,0,0,32.252,51.2ZM41.7,52.529h-.088a2.072,2.072,0,0,0-2.015,2.13v.118a2.036,2.036,0,0,0,2.047,1.987H57.868a2.12,2.12,0,0,0,.059-4.235ZM32.252,40.512A3.286,3.286,0,1,0,35.538,43.8,3.289,3.289,0,0,0,32.252,40.512Zm9.393,1.354-.058,0a2.046,2.046,0,0,0-1.986,2.1v.087A2.084,2.084,0,0,0,41.675,46.1H57.839a2.109,2.109,0,0,0,2.075-2.133,2.048,2.048,0,0,0-1.986-2.1H41.7ZM32.252,29.852a3.285,3.285,0,1,0,3.286,3.286A3.289,3.289,0,0,0,32.252,29.852ZM41.7,31.177h-.088A2.072,2.072,0,0,0,39.6,33.31v.116a2.035,2.035,0,0,0,2.043,1.988H57.868a2.121,2.121,0,0,0,.059-4.236Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnamnesis);
export default __webpack_public_path__ + "static/media/ic_anamnesis.dc4685915107d8b5a2fab21df99bb2cd.svg";
export { ForwardRef as ReactComponent };